import React, { Component } from 'react';
import ioClient from 'socket.io-client';
import {Grid, Typography, Button, Paper, MuiThemeProvider } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";
import _ from 'lodash';
import {v4 as uuidv4} from 'uuid';
import Fade from 'react-reveal/Fade';
import Swing from 'react-reveal/Swing';
import HeadShake from 'react-reveal/HeadShake';

import PlayerPrompt from '../components/PlayerPrompt';
import EndGame from '../containers/endGame';
import Timer from '../components/Timer';
import PlayerEndGameDisplay from '../containers/PlayerEndGameDisplay';
import { randomEnglishSecondAudioPath, randomEnglishMinuteAudioPath } from '../utils/englishAudioPaths';

const connection = process.env.NODE_ENV === 'development' ? 'http://www.localhost:4001' : 'https://promptdraw.boulderdynasty.com';

class Game extends Component {
  constructor(props) {
    super(props);
    this.name = props.name;
    this.socket = null;
    this.sfxAudioSrc= "";
    this.state = {
      socket: null,
      players: [],
      localPlayer: null,
      ready: false,
      gameInSession: false,
      roundTimer: "",
      roundOngoing: false,
      currentRoundData: {},
      gameOver: false,
      gameObjects: [],
      playerResults: false,
    };
  };

  componentWillMount() {
    this.listenToMessages();
  };

  listenToMessages() {
    const { roomCode } = this.props;

    this.socket = ioClient(connection);
    this.socket.on('connect', () => {
      this.props.host ? this.createRoom() : this.joinRoom();
      this.socket.emit('name', roomCode, this.name, (name) => {
        if (!this.name)
        {
          this.props.setName(name);
          this.name = name;
        }
      }); 
      this.setState({ socket: this.socket });

      this.getPlayers();

      this.socket.on('start_game', (gameInSession) =>{
        this.setState({gameInSession});
      });

      this.socket.on('round_timer', (time) => {
        this.setState({roundTimer: time});
      });

      this.socket.on('round_start', (roundData) => {
        this.setState({roundOngoing: true, currentRoundData: roundData});
      });

      this.socket.on('round_end', () => {
        this.setState({roundOngoing: false})
      });

      this.socket.on('players', (players) => {
        this.setState({players, localPlayer: _.filter(players, {'id': this.socket.id})[0]});
      });

      this.socket.on('force-disconnect', () => {
        this.props.openSnackbar("Host disconnected, ending game.");
        this.props.stopGame();
      });

      this.socket.on('end_game', (data) => {
         this.setState({
           gameObjects: data,
           gameOver: true
         });
      });

      this.socket.on('disconnect', () => {
        this.setState({ socket: null });
        this.props.setName("");
      });

      this.socket.on('player_result_objects', (gameObjects) =>
      {
        this.setState({ gameObjects, playerResults: true });
      });

      this.socket.on('reset_game', () => {
        this.setState({ 
          ready: false, 
          gameInSession: false, 
          roundOngoing: false,
          currentRoundData: {},
          gameOver: false,
          gameObjects: [],
          playerResults: false
         });
      });

    });
  };

  // Joins a created room
  joinRoom() {
    this.socket.emit("join_room", this.props.roomCode, (err) => {
      this.props.openSnackbar(err);
    });
  };

  // Creates a new room for peeps to join
  createRoom() {
    this.socket.emit("create_room", this.props.roomCode, (err) => {
      this.props.openSnackbar(err);
    });
  };

  // Sets player's ready status to get ready
  readyUp = () => {
    let isReady = !this.state.ready;
    this.socket.emit("ready", this.props.roomCode, isReady);
    this.setState({ready: isReady});
  };

  componentWillUnmount() {
    if (this.socket) this.socket.disconnect();
  };

  submitTurn = (data) => {
    this.socket.emit("submitTurn", this.props.roomCode, data);
  };

  sendGameObjectsToPlayers = () => {
    this.socket.emit("send_gameObjects_to_players", this.props.roomCode);
  };

  startNewGame = () => {
    this.socket.emit("startNewGame", this.props.roomCode);
  };

  getPlayers = () => {
    this.socket.emit('get_players', this.props.roomCode, (players) => {
      this.setState({players, localPlayer: _.filter(players, {'id': this.socket.id})[0]});
    });
  };

  timerAudio = () => {
    switch(this.state.roundTimer)
    {
      case 60:
      {
        if (!this.sfxAudioSrc.includes("1Minute"))
          this.sfxAudioSrc = `${process.env.PUBLIC_URL}/audios/${randomEnglishMinuteAudioPath()}`;

        break;
      }
      case 10:
      {
        if (!this.sfxAudioSrc.includes("10Seconds"))
          this.sfxAudioSrc = `${process.env.PUBLIC_URL}/audios/${randomEnglishSecondAudioPath()}`;

        break;
      }
      case 5:
      {
        this.sfxAudioSrc = `${process.env.PUBLIC_URL}/audios/Bells.mp3`;
        break;
      }
      case 1:
      {
        this.sfxAudioSrc = `${process.env.PUBLIC_URL}/audios/Beep.mp3`;
        this.submitTurn();
        break;
      }
      case 0:
      {
       this.sfxAudioSrc = ''; 
       break;
      }
    };

    return <audio id='audioSFX' src={this.sfxAudioSrc} autoPlay />;
  };

  musicManager = () => {
    let audioSource = "";

    if (this.state.roundOngoing && this.state.currentRoundData.data.type === "draw")
    {
      // Drawing Screen
      audioSource = `${process.env.PUBLIC_URL}/audios/OnTheOffensive.mp3`;
    }
    else if (this.state.roundOngoing && this.state.currentRoundData.data.type === "prompt")
    {
      // Prompt Screen
      audioSource = `${process.env.PUBLIC_URL}/audios/BonusGame.wav`;
    }
    else if (!this.state.roundGoing && !this.state.gameOver)
    {
      // Intermission Screen
      audioSource = `${process.env.PUBLIC_URL}/audios/MovingRightAlong.wav`;
    }
    else if (!this.state.roundGoing && this.state.gameOver)
    {
      // End Game Screen
      audioSource = `${process.env.PUBLIC_URL}/audios/DreamTune.ogg`;
    }

    return <audio id='audioMusic' src={audioSource} autoPlay loop />;
  };

  componentDidMount = () => {
    let musicAudio = document.getElementById("audioMusic");
    if (musicAudio)
    {
      musicAudio.volume = 0.7;
    }
  };

  bananaImages = () => {
    return <Swing spy={this.state.players}><img src={`${process.env.PUBLIC_URL}/images/picklebanan.png`} style={{ width: 20}} /></Swing>;
  };

  render() {
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={this.props.theme}>
        <Paper className={classes.header}>
          <Grid container spacing={2} style={{padding: 10}}>
            { this.props.host &&
              <Grid item xs={12}>
                { !this.state.gameInSession ?
                  <Fade top cascade>
                    <div>
                      <Typography variant='h4' color='secondary'>Welcome Gamers!</Typography>
                      <Typography variant='body1'> Invite your friends to play using the Room Code.</Typography>
                      <div style={{display: 'inline'}}>
                        {this.bananaImages()}
                        <Typography variant='h5' color='primary' style={{marginTop: 25, display: 'inline-flex', marginLeft: 20, marginRight: 20}}>Room Code: {this.props.roomCode}</Typography>
                        {this.bananaImages()}
                      </div>
                      <Typography variant='body1' style={{marginTop: 25}}>The game will start once all players are ready!</Typography>
                      { this.state.players &&
                        <Grid style={{marginTop: 50}} container spacing={1} item xs={12}>
                          {
                            _.map(this.state.players, (player) => {
                              return <Grid key={uuidv4()} item xs={12} sm={6} md={4} lg={4} xl={4}>
                                  <Typography style={{border: 'solid 1px', borderRadius: 5, backgroundColor: player.isReady ? player.color : 'inherit' }} variant='body2' color='primary'>{player.name}</Typography>
                                </Grid>;
                            })
                          }
                        </Grid>
                      }
                    </div>
                    { this.musicManager() }
                  </Fade>
                  : this.state.roundOngoing ?
                    <Fade>
                      <div>
                        <Typography variant='h4' color='secondary'>GO!</Typography>
                        <Timer roundTimer={this.state.roundTimer} />
                        { this.timerAudio() }
                        <Typography variant="body1">Players! Round is in session! Look at your device now!</Typography>
                        <Typography variant="caption">Submitted Players</Typography>
                        <Grid style={{marginTop: 10}} container spacing={1} item xs={12}>
                          {
                            _.map(this.state.players, (player) => {
                              return <Grid key={uuidv4()} item xs={12} sm={6} md={4} lg={4} xl={4}>
                                  <Typography style={{border: 'solid 1px', borderRadius: 5, backgroundColor: player.submittedTurn ? player.color : 'inherit' }} variant='body2' color='primary'>{player.name}</Typography>
                                </Grid>;
                            })
                          }
                        </Grid>
                      </div>
                      { this.musicManager() }
                    </Fade>
                    : !this.state.gameOver ?
                      <Fade>
                        <div>
                          <Typography variant='h4' color='secondary'>Get Ready!</Typography>
                          <Timer roundTimer={this.state.roundTimer} />
                          <Typography variant='body1'>Round starting soon!</Typography>
                          { this.state.currentRoundData.index === undefined && 
                            <audio id='audioIntro' src={`${process.env.PUBLIC_URL}/audios/Intro.mp3`} autoPlay />
                          }
                        </div>
                        { this.musicManager() }
                      </Fade>
                      :
                      <div>
                        <EndGame 
                          players={this.state.players} 
                          theme={this.props.theme}
                          gameObjects={this.state.gameObjects}
                          sendGameObjectsToPlayers={this.sendGameObjectsToPlayers}
                          startNewGame={this.startNewGame}
                        />
                        { this.musicManager() }
                      </div>
                }
              </Grid>
            }
            { !this.props.host &&
              <Grid item container spacing={2} xs={12} style={{textAlign: 'center', margin: 'auto'}}>
                <Grid item xs={12}>
                  <Fade top>
                    <Typography variant='h6' style={{display: 'block', backgroundColor: this.state.localPlayer ? this.state.localPlayer.color : 'lightgreen', borderRadius: 5}}>
                      {this.name}
                    </Typography>
                  </Fade>
                </Grid>
                { !this.state.gameInSession ?
                    <Grid container item xs={12}>
                      <Grid item xs={12}>
                        <Fade bottom>
                          <Typography variant='body1'>
                            Once you are ready press the button below! 
                          </Typography>
                        </Fade>
                      </Grid>
                      <Grid item xs={12}>
                        <Fade bottom>
                          <HeadShake spy={this.state.ready}>
                            <Button 
                              style={{marginTop: 15}}
                              variant='contained' 
                              color='primary'
                              onClick={this.readyUp}
                              disabled={this.state.players.length < 3}
                            >
                                {this.state.ready ? "Wait!" : 'Ready'}
                            </Button>
                          </HeadShake>
                        </Fade>
                      </Grid>
                      <Grid item xs={12}>
                        <Fade bottom>
                          { this.state.players.length < 3 && <Typography variant='caption' style={{display: 'block'}}>At least three players are required to play!</Typography> }
                        </Fade>
                      </Grid>
                    </Grid>
                : this.state.roundOngoing && !this.state.localPlayer.submittedTurn ?
                    <Grid container item xs={12}>
                      <div style={{textAlign: 'center', margin: 'auto'}}>
                        <Fade style={{margin: 'auto'}}>
                          <PlayerPrompt 
                            currentRoundType={this.state.currentRoundData.data.type} 
                            currentRoundIndex={this.state.currentRoundData.index} 
                            lastRoundData={_.last(this.state.localPlayer.currentGameObject.submissions)} 
                            theme={this.props.theme}
                            submitTurn={this.submitTurn}
                          />
                        </Fade>
                      </div>
                    </Grid> 
                  : !this.state.gameOver ?
                      <Grid container item xs={12}>
                        <Grid item xs={12} style={{ textAlign: "center", padding: 10, margin: 'auto' }}>
                          <Fade>
                            <Typography>Please wait till next round starts!</Typography>
                          </Fade>
                        </Grid>
                      </Grid> 
                    : !this.state.playerResults ?
                        <Grid container item xs={12}>
                          <Grid item xs={12} style={{ textAlign: "center", padding: 10, margin: 'auto' }}>
                            <Fade>
                              <Typography>The game is over.</Typography>
                              <Typography>Look at the host screen for replay.</Typography>
                            </Fade>
                          </Grid>
                        </Grid> 
                      :
                        <PlayerEndGameDisplay theme={this.state.theme} gameObjects={this.state.gameObjects} players={this.state.players} />
                }
              </Grid>
            }
          </Grid>
        </Paper>
      </MuiThemeProvider>
    );
  }
};

const styles = theme => ({
  header: {
    marginTop: 50,
    marginLeft: 20,
    marginRight: 20,
    textAlign: 'center'
  },
  textField: {
      width: 200
  },
  footer: {
      marginTop: 50
  },
  bigButtons: {
      width: 200,
      height: 200
  },
  bigButtonBigText:{
      fontSize: 'large'
  },
  bigButtonSmallText: {
      fontSize: 'x-small'
  }
});

export default withStyles(styles)(Game);